export type CreditDoc = {
  slug: string;
  name: string;
  /** Short agency descriptor, shown under the name */
  descriptor: string | null;
  url: string;
  urlLabel: string;
  /** Agency logo (single-colour SVG, painted in the current text colour) */
  logo?: { src: string; aspect: string };
  intro: string;
  roles: { title: string; body: string }[];
};

const roles = (agency: string) => [
  {
    title: 'Brand strategy',
    body: `${agency} defined the positioning of KAYS & KAYS as a family office for Capital, Culture and Longevity — the voice, the narrative and the principle of recursive quality.`,
  },
  {
    title: 'Concept',
    body: 'The guiding idea that quality amplifies quality, translated into the structure of the brand and every section of this website.',
  },
  {
    title: 'Brand design',
    body: 'Identity, wordmark and icon, typography, colour and the dotted visual language that runs through the brand.',
  },
  {
    title: 'Website design & development',
    body: 'Design, interaction, motion and front-end development of this website, from the first sketch to launch.',
  },
];

export const creditDocs: CreditDoc[] = [
  {
    slug: 'juliusbranding',
    name: 'Julius Branding',
    descriptor: null,
    url: 'https://juliusbranding.com/',
    urlLabel: 'juliusbranding.com',
    intro:
      'The KAYS & KAYS brand and this website were created by Julius Branding — strategy, concept, design and development, end to end.',
    roles: roles('Julius Branding'),
  },
  {
    slug: 'syne',
    name: 'Syne',
    descriptor: 'Design, artificial intelligence and technology agency.',
    url: 'https://syne.digital/',
    urlLabel: 'syne.digital',
    logo: { src: 'https://cdn.magicpatterns.com/uploads/t4Qc4eEokQ3NQG8fNsZ9GK/Vector.svg', aspect: 'aspect-[245/60]' },
    intro:
      'The KAYS & KAYS brand and this website were created by Syne — strategy, concept, design and development, end to end.',
    roles: roles('Syne'),
  },
];
